import { SVGProps } from 'react';

const SvgAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M12.214 13.143a2.714 2.714 0 1 0 0-5.429 2.714 2.714 0 0 0 0 5.429Zm0 2a4.714 4.714 0 1 0 0-9.429 4.714 4.714 0 0 0 0 9.429Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M17.246 19.314A8.959 8.959 0 0 1 12 21a8.958 8.958 0 0 1-5.246-1.686 2 2 0 0 1 1.96-1.6h6.572a2 2 0 0 1 1.96 1.6Zm1.585-1.454a4 4 0 0 0-3.545-2.146H8.714A4 4 0 0 0 5.17 17.86a9 9 0 1 1 13.662 0ZM23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgAvatar;
